import get from './methodGet';
import patch from './methodPatch';
import post from './methodPost';

export default { ...get, ...patch, ...post };
